import Table from 'components/Display/Table/Table'
import Page from 'components/Page/Page'
import useStructures from 'logic/Structures/useStructures'
import React from 'react'
import {
    useCreateStructureMutation,
    useDeleteStructureMutation,
    useEditStructureMutation,
    useGetStructureQuery,
    useGetStructuresQuery,
} from 'store/Store'

const Structures = () => {
    return (
        <Page>
            <Table
                itemName="structure"
                paginationType="external"
                allowDelete
                allowEdit
                allowCreate
                allowExpanded
                useEditMutation={useEditStructureMutation}
                useGetQuery={useGetStructuresQuery}
                useGetByIdQuery={useGetStructureQuery}
                useCreateMutation={useCreateStructureMutation}
                useDeleteMutation={useDeleteStructureMutation}
                useModal={useStructures}
            />
        </Page>
    )
}

export default Structures
